// extracted by mini-css-extract-plugin
export default {"content":"_3Knfq","day":"_1zaCo","past":"_2KLqj","dayText":"_1C_qz","today":"BrkhX","events":"SKCew","event":"_3wJyY"};